import { Autocomplete, Icon, InputBase, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Vendor } from "../../entities/vendor";
import { useVendor, useVendors } from "../../redux/vendor/vendorHooks";

/**
 * @param {vendorAutocompleteProps} vendorAutocompleteProps PriorityLevel object from API
 * @returns {ReactElement} Vendor Autocomplete
 */
export function VendorAutocomplete({
  vendorID,
  onChange,
  variant,
  size,
  helperText,
  disabled,
  autoFocus,
}: vendorAutocompleteProps) {
  const [inputValue, setInputValue] = useState("");
  const { vendors } = useVendors();
  const { vendor } = useVendor(vendorID);

  useEffect(() => {
    if (vendor) {
      setInputValue(vendor.name);
    }
  }, [vendor]);

  return (
    <Autocomplete
      value={vendor ?? null}
      onChange={(_e, newValue) => {
        onChange(newValue);
      }}
      disabled={disabled}
      inputValue={inputValue}
      onInputChange={(_e, newInputValue) => {
        setInputValue(newInputValue);
      }}
      size={size}
      getOptionLabel={(option) => `${option.name}`}
      options={vendors ?? []}
      clearIcon={<Icon sx={{ fontSize: 15 }} className="fa-solid fa-xmark" />}
      renderInput={(params) =>
        variant === "inputBase" ? (
          <div ref={params.InputProps.ref}>
            <InputBase
              inputProps={{ ...params.inputProps }}
              fullWidth
              sx={{ fontSize: 14 }}
              placeholder="Select a vendor..."
              autoFocus={autoFocus}
            />
          </div>
        ) : (
          <TextField
            variant={variant}
            {...params}
            fullWidth
            sx={{ fontSize: 14 }}
            placeholder="Select a vendor..."
            autoFocus={autoFocus}
            label="Vendor"
            helperText={helperText}
          />
        )
      }
    />
  );
}

type vendorAutocompleteProps = {
  vendorID?: number;
  onChange: (vendor: Vendor | null) => void;
  variant?: "standard" | "filled" | "outlined" | "inputBase" | undefined;
  size?: "small" | "medium" | undefined;
  helperText?: string;
  disabled?: boolean;
  autoFocus?: boolean;
};
